import { render, staticRenderFns } from "./AuthorizationView.vue?vue&type=template&id=4d9f161e&scoped=true&"
import script from "./AuthorizationView.vue?vue&type=script&lang=js&"
export * from "./AuthorizationView.vue?vue&type=script&lang=js&"
import style0 from "../assets/css/authorization.css?vue&type=style&index=0&id=4d9f161e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9f161e",
  null
  
)

export default component.exports